import { ApolloError, ApolloQueryResult, useQuery } from "@apollo/client";

import { QueryStackRoleBindingArgs } from "types/generated";

import { STACK_ROLE_BINDINGS_WITH_ROLES, StackRoleBindingsData } from "./gql";
import { StackRoleBindingView } from "./types";

type UseStackRoleBindingsProps = {
  stackID: string;
};

type UseStackRoleBindingsReturn = {
  stackRoleBindings: StackRoleBindingView[];
  roles: Array<{ id: string; name: string }>;
  loading: boolean;
  hasData: boolean;
  error: ApolloError | undefined;
  refetch: (
    variables?: Partial<QueryStackRoleBindingArgs>
  ) => Promise<ApolloQueryResult<StackRoleBindingsData>>;
};

const useStackRoleBindings = ({
  stackID,
}: UseStackRoleBindingsProps): UseStackRoleBindingsReturn => {
  const { data, loading, error, refetch } = useQuery(STACK_ROLE_BINDINGS_WITH_ROLES, {
    variables: {
      id: stackID,
    },
  });

  return {
    stackRoleBindings: data?.stack?.roleBindings || [],
    roles: data?.roles || [],
    loading,
    hasData: !!data?.stack?.roleBindings,
    error,
    refetch,
  };
};

export default useStackRoleBindings;
